import React from "react";
import { FaPhoneAlt, FaGlobe } from "react-icons/fa";
import images from "../Data/images";

const Consulting = () => {
  return (
    <div className="w-full text-gray-800">

      {/* Hero Section */}
      <div className="bg-[#c4122f] text-white py-16 px-6 md:px-20">
        <h1 className="text-4xl font-bold mb-4">
          Security Consulting Services
        </h1>
        <p className="text-lg max-w-xl">
          Strategic Security Planning for Modern Properties
        </p>
      </div>

      {/* Breadcrumb */}
      <div className="flex justify-between items-center py-4 px-6 md:px-20 border-b bg-gray-50">
        <span className="text-sm text-gray-500">
          HOME / SECURITY CONSULTING
        </span>

        <span className="flex items-center gap-2 text-sm text-gray-700">
          <FaPhoneAlt className="text-[#c4122f]" />
          416-477-7692
        </span>
      </div>

      {/* Intro Section */}
      <section className="py-16 px-6 md:px-20 gap-12 items-center">

        <div className="space-y-6">
          <h2 className="text-3xl font-semibold text-[#c4122f]">
            Strategic Security Planning
          </h2>

          <p>
            Effective security begins with proper planning and risk assessment.
            Security consulting services help property owners, developers, and
            organizations identify vulnerabilities and implement structured
            security strategies.
          </p>

          <p>
            Argus Security International provides professional security
            consulting services designed to assess risks, improve safety, and
            develop effective protection programs for a wide range of
            properties and environments.
          </p>

          <p>
            Our consulting services help clients make informed decisions about
            security personnel, technology, and operational procedures.
          </p>
        </div>

      </section>

      {/* Security Assessments */}
      <section className="py-14 px-6 md:px-20 bg-gray-50">

        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          Comprehensive Security Assessments
        </h2>

        <p className="mb-6">
          Argus security consultants conduct detailed evaluations of
          properties and operational environments to identify potential
          security risks.
        </p>

        <ul className="grid md:grid-cols-2 gap-3 list-disc list-inside text-gray-700">
          <li>Property security risk analysis</li>
          <li>Access control evaluation</li>
          <li>Surveillance system assessment</li>
          <li>Parking and traffic control considerations</li>
          <li>Lighting and environmental safety review</li>
          <li>CPTED evaluations</li>
          <li>Identification of vulnerabilities and security gaps</li>
        </ul>

        <p className="mt-6">
          These assessments allow us to recommend practical solutions that
          strengthen overall property security.
        </p>

      </section>

      {/* Security Program Development */}
      <section className="py-16 px-6 md:px-20">

        <h2 className="text-3xl font-semibold text-[#c4122f] mb-8">
          Security Program Development
        </h2>

        <div className="grid md:grid-cols-2 gap-8">

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Security Guard Program Design
            </h3>
            <p>
              Developing structured security guard operations for residential,
              commercial, or industrial properties.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Technology Integration
            </h3>
            <p>
              Advising on CCTV systems, access control technology, and other
              security tools to improve monitoring and control.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Property Security Planning
            </h3>
            <p>
              Designing security strategies for new developments,
              renovations, or existing properties.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Emergency Security Planning
            </h3>
            <p>
              Preparing procedures for incidents such as emergencies,
              fire watch situations, or unexpected security risks.
            </p>
          </div>

        </div>

      </section>

      {/* Clients */}
      <section className="py-14 px-6 md:px-20 bg-gray-50">

        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          Supporting Property Managers and Developers
        </h2>

        <p className="mb-6">
          Argus security consulting services are frequently used by:
        </p>

        <ul className="grid md:grid-cols-2 gap-3 list-disc list-inside text-gray-700">
          <li>Property Managers</li>
          <li>Condominium Boards</li>
          <li>Commercial Building Owners</li>
          <li>Real Estate Developers</li>
          <li>Industrial Property Operators</li>
          <li>Corporate Facilities</li>
        </ul>

        <p className="mt-6">
          These clients rely on professional security guidance to protect
          assets, maintain safety, and reduce operational risks.
        </p>

      </section>

      {/* Why Choose Argus */}
      <section className="py-16 px-6 md:px-20">

        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          Why Choose Argus Security Consulting
        </h2>

        <ul className="space-y-3 text-gray-700">
          <li>✔ Professional security risk assessments</li>
          <li>✔ Practical recommendations for property protection</li>
          <li>✔ Expertise in security personnel and technology integration</li>
          <li>✔ Support for property managers and developers</li>
          <li>✔ Customized security strategies for each client</li>
        </ul>

      </section>

      {/* CTA */}
      <section className="py-16 px-6 md:px-20 bg-[#c4122f] text-white text-center">

        <h2 className="text-3xl font-semibold mb-6">
          Security Expertise You Can Trust
        </h2>

        <p className="max-w-3xl mx-auto mb-6">
          Argus Security International provides professional consulting
          services designed to help organizations strengthen security and
          reduce risk.
        </p>

        <p className="mb-6 font-semibold">
          Our goal is simple: Provide clear guidance and practical solutions
          that improve safety and protection.
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-6 text-lg">

          <span className="flex items-center gap-2">
            <FaPhoneAlt />
            416-477-7692
          </span>

          <span className="flex items-center gap-2">
            <FaGlobe />
            www.argussecurity.ca
          </span>

        </div>

      </section>

    </div>
  );
};

export default Consulting;